import { createStore } from "@stencil/store";

interface AuthState {
    token: string | null;
    isAuthenticated: boolean;
}

const { state, onChange, dispose } = createStore<AuthState>({
    token: null,
    isAuthenticated: false
});

// Function to explicitly set the token and update isAuthenticated
const setToken = (newToken: string | null) => {
    state.token = newToken;
    state.isAuthenticated = !!newToken;
};

// Optional: Export a way to reset the store if needed, e.g., on logout
const resetAuthStore = () => {
    state.token = null;
    state.isAuthenticated = false;
};

export default {
    state,
    onChange,
    dispose,
    setToken,
    resetAuthStore
};
